import React from 'react';

import { useLocation, useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';

import { PromotionCompleted } from '@entities/promotion-completed';

const PromotionCompletedPage = () => {
	const location = useLocation();
	const { promotionIdFallback } = useParams<{ promotionIdFallback: string }>();
	const navigate = useNavigate();

	const { promotionId } = location.state ? location.state : '';

	React.useEffect(() => {
		if (promotionIdFallback === undefined && promotionId === undefined) {
			navigate('/all-promotions');
		}
	}, [promotionId, navigate]);

	const id: string = promotionId;

	return <PromotionCompleted id={id} />;
};

export default PromotionCompletedPage;
